import React from "react";
import { HiOutlineExternalLink } from "react-icons/hi";
import { VscCode } from "react-icons/vsc";
import { AiFillGithub } from "react-icons/ai";

function ProjectCard({ project, compact = false }) {
  return (
    <div className={`project-card${compact ? " compact" : ""}`}>
      <div className="project-card-header">
        <div className="project-icon">
          <VscCode />
        </div>
        <div className="project-card-links">
          {project.githubLink && (
            <a
              href={project.githubLink}
              target="_blank"
              rel="noreferrer"
              className="project-link-icon"
              aria-label={`View ${project.title} on GitHub`}
            >
              <AiFillGithub />
            </a>
          )}
          {project.liveLink && (
            <a
              href={project.liveLink}
              target="_blank"
              rel="noreferrer"
              className="project-link-icon"
              aria-label={`Visit ${project.title}`}
            >
              <HiOutlineExternalLink />
            </a>
          )}
        </div>
      </div>

      <div className="project-title">{project.title}</div>
      <div className="project-subtitle">{project.subtitle}</div>
      <p className="project-description">{project.description}</p>

      <div className="project-stack">
        {project.stack.map((tag) => (
          <span key={tag} className="stack-tag">{tag}</span>
        ))}
      </div>
    </div>
  );
}

export default ProjectCard;

